import { inject, observer } from "mobx-react";
import React from "react";
import { Grid, Row, Col, Alert, Glyphicon } from "react-bootstrap";

@inject("detailViewStore")
@observer
class FacetRepresentation extends React.Component {
  render() {
    const { fetchingDataStatus } = this.props.detailViewStore;
    const { entityData } = this.props;
    const facetData =
      entityData &&
      entityData.navigationLookupResult &&
      entityData.navigationLookupResult.navigationLookupBuckets &&
      entityData.navigationLookupResult.navigationLookupBuckets
        .FacetEnumerations &&
      entityData.navigationLookupResult.navigationLookupBuckets
        .FacetEnumerations.objects
        ? entityData.navigationLookupResult.navigationLookupBuckets
            .FacetEnumerations.objects
        : [];
    if (facetData.length < 1 && !fetchingDataStatus.get("FacetEnumerations"))
      return null;

    const additionalHeaderName =
      entityData &&
      entityData.object &&
      entityData.object.type === "Variable" ? (
        // <div className="alert alert-warning" role="alert">
        //   <span
        //     className="glyphicon glyphicon glyphicon-info-sign"
        //     aria-hidden="true"
        //   ></span>
        //   <span className="sr-only">Info:</span> More restrictive constraints
        //   could be defined in the context of a specific Cube that includes this
        //   Variable
        // </div>
        <Alert bsStyle="warning">
          <div>
            <Glyphicon glyph="info-sign" /> More restrictive constraints could
            be defined in the context of a specific Cube that includes this
            Variable.
          </div>
        </Alert>
      ) : (
        ""
      );

    return (
      <div className="mapping custom-panel">
        <div className="custom-panel-heading">
          <h4>
            Constraints
            {fetchingDataStatus.get("FacetEnumerations") === true ? (
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            ) : (
              ""
            )}
          </h4>
        </div>
        <div className="custom-panel-body">
          <div className="item-list-container">
            <Grid fluid={true}>
              {additionalHeaderName}
              {facetData.map((f) => (
                <Row
                  className="facets"
                  style={{
                    marginBottom: "10px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <Col xs={1}>{f.facetType}</Col>
                  <Col xs={11}>{f.observationValue}</Col>
                </Row>
              ))}
              {facetData
                .filter((f) => f.facetType === "pattern")
                .slice(0, 1)
                .map((f) => (
                  <Row className="facets">
                    <Col xs={1}></Col>
                    <Col xs={11}>
                      <div>
                        If you want to understand regular expressions under{" "}
                        <i>pattern</i> item(s), you can use e.g.{" "}
                        <a
                          className="pattern"
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://regexr.com/"
                        >
                          https://regexr.com
                        </a>
                        . Copy and paste the value into respective expression
                        input box.
                        <br />
                        <b>
                          Disclaimer: The link refers to an external website for
                          which we are not responsible.
                        </b>
                      </div>
                    </Col>
                  </Row>
                ))}
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default FacetRepresentation;
